import { useApplePayActions } from 'modules/profile/payment-gateways/integrations/stripe/hooks'
import React, { useState } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { BinIcon } from '@systemeio/ui'

interface ApplePayDeleteDomainModalProps {
  domainId: number
  hostName: string
  afterLeave: () => void
}

const ApplePayDeleteDomainModal = ({
  domainId,
  hostName,
  afterLeave,
}: ApplePayDeleteDomainModalProps) => {
  const [opened, setOpened] = useState(false)
  const { disconnectDomain } = useApplePayActions()

  const handleConfirm = async () => {
    await disconnectDomain(domainId)
    setOpened(false)
  }

  return (
    <>
      <div className="flex">
        <span>{hostName}</span>
        <BinIcon
          onClick={() => setOpened(true)}
          className={'fill-danger mb-0.5 h-[16px] w-[16px] cursor-pointer'}
        />
      </div>
      <ConfirmationModal
        opened={opened}
        afterLeave={afterLeave}
        onClose={() => setOpened(false)}
        onConfirm={handleConfirm}
      />
    </>
  )
}

export default ApplePayDeleteDomainModal
